import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LazyBgLoaderDirective, LocalizedDatePipe } from '@shared';

export interface PhotoCardData {
  imageUrl: string;
  chipText?: string;
  title: string;
  titleColor?: string;
  description?: string;
  dateText?: string | Date;
  tags?: string[];
}

@Component({
  selector: 'k-photo-card',
  standalone: true,
  imports: [ LazyBgLoaderDirective, NgClass, TranslateModule, LocalizedDatePipe ],
  templateUrl: './photo-card.component.html',
  styleUrl: './photo-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoCardComponent {
  data = input.required<PhotoCardData>();
  clickable = input(false);
  aspectRatio = input<'square' | 'portrait' | 'landscape'>('square');
  showChipOnImage = input(true);
  showHoverEffect = input(true);

  cardClick = output<void>();
  imageLoaded = output<void>();

  onCardClick(): void {
    if (this.clickable()) {
      this.cardClick.emit();
    }
  }

  onImageLoaded(): void {
    this.imageLoaded.emit();
  }

  isDate(value: string | Date | undefined): value is Date {
    return value instanceof Date;
  }

  aspectRatioClass = computed(() => {
    switch (this.aspectRatio()) {
      case 'square':
        return 'aspect-square';
      case 'portrait':
        return 'aspect-[3/4]';
      case 'landscape':
        return 'h-72';
      default:
        return 'aspect-square';
    }
  });
}
